import { Link } from 'react-router-dom'
// import styles from './navbar.module.css'
import styles from './sidebar.module.scss'

import { useDispatch, useSelector } from 'react-redux'
import { disconnectSocket, logout } from '../../features/authSlice'
import { resetMessageSlice } from '../../features/messageSlice'
import { toastHelper } from '../../util/toastHelper'

// MUI icons
import { Tooltip, Typography } from '@mui/material'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'

import { useEffect } from 'react'
import { countUnreadNotifications } from '../../features/notificationSlice'
import { toggleSidebar } from '../../features/sidebarSlice'
import { NavItem } from './NavItem'

// Sidebar navigation component for navigating between app sections
// Props:
// - disabled: boolean flag to disable access to main features until onboarding is complete

const createRoleBasedRoutes = (userId, userPayment) => ({
	user: [
		{
			id: 'home',
			icon: '/images/home-2.svg',
			label: 'Home',
			to: '/user-dashboard',
			dataCy: 'dashboard',
		},
		{
			id: 'vendors',
			icon: '/images/buliding.svg',
			label: 'Vendor Marketplace',
			to: '/vendors-list',
			dataCy: 'vendors-list-button',
		},
		{
			id: 'venues',
			icon: '/images/venues-icn.svg',
			label: 'Venues Marketplace',
			to: '/venues-list',
			dataCy: 'venues-list-button',
		},
		{
			id: 'planners',
			icon: '/images/planner-icon.svg',
			label: 'Planner Marketplace',
			to: '/planners-list',
			dataCy: 'planners-list-button',
		},
		{
			id: 'friends',
			icon: '/images/member-icon.svg',
			label: 'Friends',
			to: '/members',
			dataCy: 'members-button',
		},
		{
			id: 'chat',
			icon: '/images/chat-icon.svg',
			label: 'Chat',
			to: '/chat',
			dataCy: 'chat-link',
		},
	],
	vendor: [
		{
			id: 'home',
			icon: '/images/home-2.svg',
			label: 'Home',
			to: '/user-dashboard',
			dataCy: 'dashboard',
		},
		{
			id: 'vendorWeddings',
			icon: '/images/lovely.svg',
			label: 'Weddings',
			to: '/vendor-weddings',
			dataCy: 'dashboard',
		},
		{
			id: 'vendorProfile',
			icon: '/images/profile-user.svg',
			label: 'Public Profile',
			to: `/profile/${userId}`,
			dataCy: 'vendor-profile',
		},
		{
			id: 'vendorSchedule',
			icon: '/images/timeline-icon.svg',
			label: 'Schedule',
			to: '/vendor-timeline',
			dataCy: 'vendor-timeline',
		},
		{
			id: 'vendorStaffs',
			icon: <BadgeOutlinedIcon style={{ color: '#7ca6bd' }} />,
			label: 'Staff',
			to: '/invite-staff',
			dataCy: 'vendor-staffs-link',
			isIconComponent: true,
		},
		{
			id: 'vendorTasks',
			icon: '/images/task-square-blue.svg',
			label: 'Tasks',
			to: '/vendor-tasks',
			dataCy: 'vendor-tasks-link',
		},
		{
			id: 'vendorProposals',
			icon: '/images/proposal-icon.svg',
			label: 'Proposals',
			to: '/vendor-proposal',
			dataCy: 'proposal-link',
		},
		/* TODO: uncomment when implemented */
		// {
		// 	id: 'vendorPayments',
		// 	icon: '/images/budget.svg',
		// 	label: 'Payments',
		// 	to: '/vendor-payments',
		// 	dataCy: 'vendor-payments-link',
		// },
		{
			id: 'friends',
			icon: '/images/member-icon.svg',
			label: 'Friends',
			to: '/vendor-friends',
			dataCy: 'friends-button',
		},
		{
			id: 'chat',
			icon: '/images/chat-icon.svg',
			label: 'Chat',
			to: '/chat',
			dataCy: 'chat-link',
		},
	],
	'kazoo-planner': [
		{
			id: 'home',
			icon: '/images/home-2.svg',
			label: 'Home',
			to: '/user-dashboard',
			dataCy: 'dashboard',
		},
		{
			id: 'plannerWeddings',
			icon: '/images/lovely.svg',
			label: 'Weddings',
			to: '/planner-weddings',
			dataCy: 'dashboard',
		},
		{
			id: 'weddingPlannerProfile',
			icon: '/images/profile-user.svg',
			label: 'Public Profile',
			to: `/profile/${userId}`,
			dataCy: 'planner-profile',
		},
		{
			id: 'vendorSchedule',
			icon: '/images/timeline-icon.svg',
			label: 'Schedule',
			to: '/planner-timeline',
			dataCy: 'planner-timeline',
		},
		// Staff module only available for wedding planners with business-pro-month payment
		...(userPayment === 'business-pro-month' ? [{
			id: 'vendorStaffs',
			icon: <BadgeOutlinedIcon style={{ color: '#7ca6bd' }} />,
			label: 'Staff',
			to: '/planner-invite-staff',
			dataCy: 'planner-staffs-link',
			isIconComponent: true,
		}] : []),
		{
			id: 'weddingPlannerTasks',
			icon: '/images/task-square-blue.svg',
			label: 'Tasks',
			to: '/planner-tasks',
			dataCy: 'planner-tasks-link',
		},
		{
			id: 'weddingPlannerProposals',
			icon: '/images/proposal-icon.svg',
			label: 'Proposals',
			to: '/planner-proposal',
			dataCy: 'proposal-link',
		},
		/* TODO: uncomment when implemented */
		// {
		// 	id: 'weddingPlannerPayments',
		// 	icon: '/images/budget.svg',
		// 	label: 'Payments',
		// 	to: '/planner-payments',
		// 	dataCy: 'planner-payments-link',
		// },
		{
			id: 'friends',
			icon: '/images/member-icon.svg',
			label: 'Friends',
			to: '/planner-friends',
			dataCy: 'friends-button',
		},
		{
			id: 'chat',
			icon: '/images/chat-icon.svg',
			label: 'Chat',
			to: '/chat',
			dataCy: 'chat-link',
		},
	],
	'vendor-staff': [
		{
			id: 'home',
			icon: '/images/home-2.svg',
			label: 'Home',
			to: '/user-dashboard',
			dataCy: 'dashboard',
		},
		{
			id: 'vendorStaffWeddings',
			icon: '/images/lovely.svg',
			label: 'Weddings',
			to: '/vendor-staff/weddings',
			dataCy: 'dashboard',
		},
		{
			id: 'vendorStaffTasks',
			icon: '/images/task-square-blue.svg',
			label: 'Tasks',
			to: '/vendor-staff/tasks',
			dataCy: 'vendor-staff-tasks-link',
		},
		{
			id: 'vendorStaffSchedule',
			icon: '/images/timeline-icon.svg',
			label: 'Schedule',
			to: '/vendor-staff/timeline',
			dataCy: 'vendor-staff-timeline',
		},
		{
			id: 'chat',
			icon: '/images/chat-icon.svg',
			label: 'Chat',
			to: '/chat',
			dataCy: 'chat-link',
		},
		{
			id: 'vendorStaffTimeManagement',
			icon: '/images/clock-blue.svg',
			label: 'Time Management',
			to: '/vendor-staff/time-management',
			dataCy: 'vendor-staff-time-management',
		},
	],
	'planner-staff': [
		{
			id: 'home',
			icon: '/images/home-2.svg',
			label: 'Home',
			to: '/user-dashboard',
			dataCy: 'dashboard',
		},
		{
			id: 'plannerStaffWeddings',
			icon: '/images/lovely.svg',
			label: 'Weddings',
			to: '/vendor-staff/weddings',
			dataCy: 'dashboard',
		},
		{
			id: 'plannerStaffTasks',
			icon: '/images/task-square-blue.svg',
			label: 'Tasks',
			to: '/vendor-staff/tasks',
			dataCy: 'planner-staff-tasks-link',
		},
		{
			id: 'plannerStaffSchedule',
			icon: '/images/timeline-icon.svg',
			label: 'Schedule',
			to: '/vendor-staff/timeline',
			dataCy: 'planner-staff-timeline',
		},
		{
			id: 'chat',
			icon: '/images/chat-icon.svg',
			label: 'Chat',
			to: '/chat',
			dataCy: 'chat-link',
		},
		{
			id: 'plannerStaffTimeManagement',
			icon: '/images/clock-blue.svg',
			label: 'Time Management',
			to: '/vendor-staff/time-management',
			dataCy: 'planner-staff-time-management',
		},
	],
})

export const UserSideNavbar = ({ disabled }) => {
	const dispatch = useDispatch()

	const accountType = useSelector((state) => state.auth.accountType)
	const userId = useSelector((state) => state.auth.user._id)
	const userPayment = useSelector((state) => state.auth.user?.payment)

	// Logs the user out
	const handleLogout = async () => {
		dispatch(disconnectSocket())
		dispatch(logout())
	}

	// Handler for all sidebar clicks — shows warning if access is restricted
	const HandleOnClick = () => {
		if (disabled) {
			toastHelper(
				'Please complete the onboarding process to access other features!',
				'info'
			)
		}
	}

	const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen)
	const handleSidebarExpand = () => {
		dispatch(toggleSidebar())
	}

	const roleBasedRoutesData = createRoleBasedRoutes(userId, userPayment)
	const currentRoutes =
		accountType && roleBasedRoutesData[accountType]
			? roleBasedRoutesData[accountType]
			: [
				{
					id: 'home',
					icon: '/images/home-2.svg',
					label: 'Home',
					to: '/user-dashboard',
					dataCy: 'dashboard',
				},
			]

	const handleChatClick = (e) => {
		dispatch(resetMessageSlice())
	}

	useEffect(() => {
		dispatch(countUnreadNotifications())
	}, [dispatch])

	return (
		<>
			<div className={`${styles.SideNavbar} SideNavbar`} data-cy="side-navbar">
				<div className={styles.sideTop}>
					{isSidebarOpen ? (
						<Link to="/" className={styles.sidebarLogoFull}>
							<img
								src={'/images/ontimebridelogo.svg'}
								alt="Wedding Planner Logo"
							/>
						</Link>
					) : (
						<Link to="/" className={styles.sidebarLogo}>
							<img
								src={'/images/sidebarLogo.svg'}
								alt="Wedding Planner Logo"
							/>
						</Link>
					)}

					<ul onClick={HandleOnClick} className={styles.topNav}>
						<div className={!!disabled ? styles.disabledLink : ''}>
							{currentRoutes?.map((route) => (
								<NavItem
									key={route.id}
									icon={route.icon}
									label={route.label}
									to={route.to}
									dataTestId={route.dataCy}
									isSidebarOpen={isSidebarOpen}
									isIconComponent={route.isIconComponent}
									onClick={
										route.id === 'chat'
											? handleChatClick
											: undefined
									}
								/>
							))}
						</div>
					</ul>
				</div>
				<ul className={styles.bottomNav}>
					{/* TODO:: uncomment when implemented */}
					{/* <NavItem
						icon="/images/help-Icon.svg"
						label="help"
						to="#"
						dataTestId="help"
						isSidebarOpen={isSidebarOpen}
					/> */}
					{/* <NavItem
						icon="/images/setting-icon.svg"
						label="setting"
						to="#"
						dataTestId="setting"
						isSidebarOpen={isSidebarOpen}
					/> */}
					<li data-cy="logout">
						<Tooltip
							title="Log Out"
							placement="right"
							disableInteractive
							arrow
						>
							<button
								type="button"
								onClick={handleLogout}
								className={styles.logoutButton}
							>
								<img
									src="/images/logout-icon.svg"
									alt="setting-icon.svg"
								// onClick={handleLogout}
								/>
								{isSidebarOpen && (
									<Typography
										variant="body1"
										className={`${styles.linkText} linkText`}
									>
										logout
									</Typography>
								)}
							</button>
						</Tooltip>
					</li>
				</ul>
			</div>
			<div className="overlay" onClick={handleSidebarExpand}></div>
		</>
	)
}
